var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, css, LitElement } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { property } from "lit/decorators/property.js";
export let ToastNotificationPage = class ToastNotificationPage extends LitElement {
    constructor() {
        super(...arguments);
        this.toastMessage = "toast message";
    }
    connectedCallback() {
        super.connectedCallback();
    }
    show(text = '', duration = 3000) {
        return new Promise((resolve, reject) => {
            if (this.className === 'show') {
                // Do nothing, prevent spamming
            }
            else {
                this.toastMessage = text;
                this.className = 'show';
                setTimeout(() => {
                    this.toastMessage = '';
                    this.className = this.className.replace('show', '');
                    resolve(null);
                }, duration >= 1000 ? duration : 3000);
            }
        });
    }
    render() {
        return html `<div class="toast">${this.toastMessage}</div>`;
    }
};
ToastNotificationPage.styles = css `
    :host {
      position: fixed;
      top: 15%;
      right: 0;
      transform: translateX(-50%);
      background-color: #333;
      color: #fff;
      padding: 10px 20px;
      border-radius: 5px;
      box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
      display: none;
      z-index: 2000;
    }

    :host(.show) {
        display: block;
    }
  `;
__decorate([
    property({ reflect: true })
], ToastNotificationPage.prototype, "toastMessage", void 0);
ToastNotificationPage = __decorate([
    customElement("toast-notification")
], ToastNotificationPage);
